import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import {
	IBankScoringPayload,
	IBankScoringUrlPayload,
	IIrpfInitPayload,
	IIrpfOptPayload,
	IScriptureInitPayload,
	IWorkLifeInitPayload,
	IWorkLifeOptPayload,
} from '../../models/connection';

@Injectable({
	providedIn: 'root',
})
export class ConnectionsService extends ApiService {
	constructor() {
		super();
	}

	// WORK LIFE
	public workLifeInit(body: IWorkLifeInitPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/worklife`, body, {
			headers: this.getHeaders(),
		});
	}

	public workLifeOtp(body: IWorkLifeOptPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/worklife`, body, {
			headers: this.getHeaders(),
		});
	}

	public workLifeManual(body: FormData): Observable<any> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<any>(environment.identity2 + `/connection/worklife`, body, {
			headers: headers,
		});
	}

	public workLifeFinish(id: string): Observable<any> {
		return this.http.post<any>(
			environment.identity2 + `/connection/worklife`,
			{ status: false, uuid_config: id },
			{
				headers: this.getHeaders(),
			},
		);
	}

	// IRPF
	public irpfInit(body: IIrpfInitPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/irpf`, body, {
			headers: this.getHeaders(),
		});
	}

	public irpfOtp(body: IIrpfOptPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/irpf`, body, {
			headers: this.getHeaders(),
		});
	}

	public irpfManual(body: FormData): Observable<any> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<any>(environment.identity2 + `/connection/irpf`, body, {
			headers: headers,
		});
	}

	public irpfFinish(id: string): Observable<any> {
		return this.http.post<any>(
			environment.identity2 + `/connection/irpf`,
			{ status: false, uuid_config: id },
			{
				headers: this.getHeaders(),
			},
		);
	}

	// SCRIPTURE
	public scriptureInit(body: IScriptureInitPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/scripture`, body, {
			headers: this.getHeaders(),
		});
	}

	public scriptureManual(body: FormData): Observable<any> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<any>(environment.identity2 + `/connection/scripture`, body, {
			headers: headers,
		});
	}

	public scriptureFinish(id: string): Observable<any> {
		return this.http.post<any>(
			environment.identity2 + `/connection/scripture`,
			{ status: false, uuid_config: id },
			{
				headers: this.getHeaders(),
			},
		);
	}

	// BANK SCORING
	public bankScoringUrl(body: IBankScoringUrlPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/bankscoring/url`, body, {
			headers: this.getHeaders(),
		});
	}

	public bankScoring(body: IBankScoringPayload): Observable<any> {
		return this.http.post<any>(environment.identity2 + `/connection/bankscoring/scoring`, body, {
			headers: this.getHeaders(),
		});
	}
}
